const principles = [
  { icon: 'ri-time-line', title: '及时', text: '紧盯全网动态，重要进展第一时间同步，关键节点不遗漏。' },
  { icon: 'ri-stack-line', title: '全面', text: '娱乐、影视、综艺、社会、资讯、热梗六大频道，覆盖面广。' },
  { icon: 'ri-list-check-3', title: '清晰', text: '频道筛选 + 关键词搜索 + 热榜排行，找料快，读料轻松。' },
  { icon: 'ri-compasses-line', title: '严谨', text: '聚合公开信息并标注方向，尊重原创版权，请以权威来源为准。' },
];

export default function AboutSection() {
  return (
    <section id="about" className="scroll-mt-20 bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="grid items-center gap-10 lg:grid-cols-[1fr_1fr]">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-50 px-3 py-1 text-xs font-bold text-accent-700 ring-1 ring-accent-200">
              <i className="ri-information-line" />
              关于我们
            </span>
            <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">
              做帮你「不错过任何关键节点」的看料站
            </h2>
            <p className="mt-4 text-base leading-relaxed text-foreground-700">
              看料站是一处以"实时更新追踪"为核心的资讯速报站。我们紧盯全网娱乐、影视综艺与社会热点的最新动态，
              用滚动更新的速报、直观的热榜与清晰的事件脉络，帮你把碎片化信息整理成好读、好找、好追的样子。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              我们相信：真正有价值的追更，不只是第一时间看到"新料"，更是能从容看懂一件事为什么会被关注、
              进展到哪一步、后续还会怎么走。为此，我们把内容做成可筛可选、可按时间线回看的形态，
              让你省下翻来翻去的时间，把注意力放在真正感兴趣的内容上。
            </p>

            <a
              href="mailto:hello@kanliaozhan.example"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition hover:bg-primary-600"
            >
              线索与反馈 · hello@kanliaozhan.example
              <i className="ri-mail-send-line" />
            </a>
          </div>

          <div className="grid gap-4 sm:grid-cols-2">
            {principles.map((p) => (
              <div
                key={p.title}
                className="rounded-2xl border border-background-200/80 bg-background-50 p-5 transition hover:border-primary-200 hover:-translate-y-0.5"
              >
                <span className="grid h-10 w-10 place-items-center rounded-xl bg-primary-500 text-background-50">
                  <i className={p.icon} style={{ fontSize: 18 }} />
                </span>
                <h3 className="mt-3 font-heading text-lg text-foreground-950">{p.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{p.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}